var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "registration-symbol",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c("el-autocomplete", {
        attrs: {
          clearable: true,
          maxlength: 7,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          "fetch-suggestions": _vm.querySearch,
          "trigger-on-focus": false,
          autofocus: _vm.autofocus
        },
        model: {
          value: _vm.registrationSymbol,
          callback: function($$v) {
            _vm.registrationSymbol = $$v
          },
          expression: "registrationSymbol"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }